module.exports = __webpack_public_path__ + "static/img/slide-2.09e2aaa5.jpg";